// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updatePipCodeRequestListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_PIP_CODE_REQUESTS_FILTER_BY
});

export const updatePipCodeRequestListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_BY
});

export const updatePipCodeRequestListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/pip-code-request-search-filters.js